import { rgba } from 'polished'
import { breakpoints } from './breakpoints'

interface DefaultColors {
  primary: string
  primaryLight: string
  secondary: string
  white: string
  dark: string
  black: string
  yellow: string
  ash: string
  green: string
  red: string
  info: string
  mediumGray: string
  lightGray: string
  darkGray: string
  light: string
  bgDarkGray: string
}

interface ColorMode {
  primary: string
  primaryLight: string
  secondary: string
  light: string
  lightShade: string
  dark: string
  black: string
  darkShade: string
  ash: string
  bg: string
  border: string
  shadow: string
  heading: string
  text: string
  warning: string
  success: string
  info: string
  lightGray: string
  mediumGray: string
  darkGray: string
  yellow: string
  green: string
  red: string
  bgDarkGray: string
}

interface Colors extends ColorMode {
  lighter: string
  modes: {
    dark: ColorMode
  }
}

interface Theme {
  initialColorModeName: string
  colors: Colors
  space: number[]
  breakpoints: string[]
}

const defaultColors: DefaultColors = {
  primary: '#0057B3',
  primaryLight: '#3B96FF',
  secondary: '#293138',
  white: '#ffffff',
  dark: '#19191b',
  black: '#000000',
  yellow: '#fedc5a',
  ash: '#413e65',
  green: '#27cb94',
  red: '#f2587c',
  info: '#7a9dff',
  mediumGray: '#9f9f9f',
  lightGray: '#FAFAFA',
  darkGray: '#2B2F36',
  light: '#f8f9fa',
  bgDarkGray: '#191B20',
}

const colors: Colors = {
  primary: defaultColors.primary,
  primaryLight: defaultColors.primaryLight,
  secondary: defaultColors.secondary,
  light: defaultColors.white,
  lightShade: rgba(defaultColors.white, 0.75),
  lighter: rgba(defaultColors.white, 0.5),
  dark: defaultColors.dark,
  black: defaultColors.black,
  darkShade: rgba(defaultColors.dark, 0.75),
  yellow: defaultColors.yellow,
  ash: defaultColors.ash,
  green: defaultColors.green,
  red: defaultColors.red,
  bg: defaultColors.light,
  border: rgba(defaultColors.ash, 0.115),
  shadow: rgba(defaultColors.ash, 0.175),
  heading: defaultColors.dark,
  text: rgba(defaultColors.dark, 0.75),
  warning: defaultColors.yellow,
  success: defaultColors.green,
  info: defaultColors.info,
  lightGray: defaultColors.lightGray,
  mediumGray: defaultColors.mediumGray,
  darkGray: defaultColors.darkGray,
  bgDarkGray: defaultColors.bgDarkGray,

  modes: {
    dark: {
      primary: defaultColors.primary,
      primaryLight: defaultColors.primaryLight,
      secondary: defaultColors.secondary,
      light: defaultColors.white,
      lightShade: rgba(defaultColors.white, 0.75),
      dark: defaultColors.dark,
      black: defaultColors.black,
      darkShade: rgba(defaultColors.dark, 0.75),
      ash: defaultColors.ash,
      bg: defaultColors.dark,
      border: rgba(defaultColors.ash, 0.115),
      shadow: rgba(defaultColors.ash, 0.175),
      heading: defaultColors.white,
      text: rgba(defaultColors.white, 0.75),
      warning: defaultColors.yellow,
      success: defaultColors.green,
      info: defaultColors.info,
      lightGray: defaultColors.lightGray,
      mediumGray: defaultColors.mediumGray,
      darkGray: defaultColors.darkGray,
      yellow: defaultColors.yellow,
      green: defaultColors.green,
      red: defaultColors.red,
      bgDarkGray: defaultColors.bgDarkGray,
    },
  },
}

const theme: Theme = {
  initialColorModeName: 'light',
  colors: colors,
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  breakpoints: [
    `${breakpoints.sm}px`,
    `${breakpoints.md}px`,
    `${breakpoints.lg}px`,
    `${breakpoints.xl}px`,
  ],
}

export default theme 